import { render, staticRenderFns } from "./delivery-orders-ekiosk.vue?vue&type=template&id=5ad8c265&"
import script from "./delivery-orders-ekiosk.vue?vue&type=script&lang=js&"
export * from "./delivery-orders-ekiosk.vue?vue&type=script&lang=js&"
import style0 from "./delivery-orders-ekiosk.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports